import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  shake?: boolean;
  compact?: boolean;
};
export function CtaButton({
  label,
  sub,
  id,
  shake = false,
  compact = false
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`mx-auto flex w-full max-w-xl flex-col items-center justify-center rounded-2xl bg-volt text-center text-ink shadow-[0_6px_0_0_#a16207,0_14px_30px_-8px_rgba(250,204,21,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-voltlight active:translate-y-[4px] active:shadow-[0_2px_0_0_#a16207] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-spark/70 ${compact ? 'px-4 py-3' : 'px-5 py-4 sm:py-5'} ${shake ? 'motion-safe:animate-shake' : ''}`} data-id="element-98" data-mp="cjznxxaitf63">
      <span className={`flex items-center justify-center gap-2 font-display font-extrabold uppercase leading-[1.05] tracking-wide ${compact ? 'text-xl' : 'text-[22px] sm:text-[28px]'}`} data-id="element-99" data-mp="15areae4wn9li">
        <span data-id="element-100" data-mp="39z14z3bzy3pr">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="3exudehcff4j2" />
      </span>
      {sub && <span className="mt-1.5 text-xs font-semibold text-ink/75 sm:text-sm" data-id="element-102" data-mp="3jxgq8poceirc">{sub}</span>}
    </a>;
}